module.exports = __webpack_public_path__ + "img/web-design.9ba224f3.svg";